import ActionButtons from '@/components/common/ActionButtons';
import Table from '@/components/common/table/Table';
import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { useEstimatedArrival } from '@/context/estimatedArrival/EstimatedArrivalContextProvider';
import { BsFiletypeXml } from 'react-icons/bs';
import { SearchInput } from '@/components';
import { useDebouncedCallback } from '@/utils/useDebouncedCallback';

const ETATable = () => {
  const {
    estimatedArrivals,
    getEstimatedArrivalsAPI,
    unloadETAFileByIdAPI,
    totalElements,
    currentPage,
    pageSize,
    setCurrentPage,
    setPageSize,
    searchQuery,
    setSearchQuery,
  } = useEstimatedArrival();
  const [inputValue, setInputValue] = useState('');

  React.useEffect(() => {
    getEstimatedArrivalsAPI();
  }, [currentPage, pageSize, searchQuery]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
    setCurrentPage(0);
  }, 300);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };

  const columns = [
    {
      header: 'File Name',
      render: (file) => (
        <div className="flex items-center gap-5">
          <div>
            <BsFiletypeXml className="text-xl" />
          </div>
          <div>
            <div className="font-bold text-black font-700 text-lg">
              {file.fileName}
            </div>
            <small className="text-gray-500 text-sm font-mono">
              {file.fileUploadedDate}
            </small>
          </div>
        </div>
      ),
    },
    {
      header: 'ACTIONS',
      render: (file) => (
        <ActionButtons
          actions={[
            {
              icon: <FaTrash />,
              onClick: () => unloadETAFileByIdAPI(file.id),
              tooltip: 'Delete File',
              className: 'text-red-500 hover:text-red-700',
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="w-full flex justify-end">
        <SearchInput
          className="w-60"
          value={inputValue}
          onChange={handleSearchChange}
          onSearchClick={handleSearch}
        />
      </div>

      <Table
        columns={columns}
        data={estimatedArrivals}
        totalElements={totalElements}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
      />
    </div>
  );
};

export default ETATable;
